import React from "react";

export default ({ className }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
    <path fillRule="evenodd"
          d="M8,16 C3.581722,16 0,12.418278 0,8 C0,3.581722 3.581722,0 8,0 C12.418278,0 16,3.581722 16,8 C16,12.418278 12.418278,16 8,16 Z M11.649646,5.14327592 L6.90909091,9.79917823 L4.35035401,7.28613306 C4.15334074,7.09263789 3.8367711,7.09548987 3.64327592,7.29250314 C3.44978074,7.4895164 3.45263272,7.80608605 3.64964599,7.99958122 L6.5587369,10.8567241 C6.75324482,11.0477586 7.064937,11.0477586 7.25944492,10.8567241 L12.350354,5.85672408 C12.5473673,5.6632289 12.5502193,5.34665926 12.3567241,5.14964599 C12.1632289,4.95263272 11.8466593,4.94978074 11.649646,5.14327592 Z"/>
  </svg>
)
